// extracted by mini-css-extract-plugin
export var root = "PricesGroup-module--root--1ELMj";
export var header = "PricesGroup-module--header--km1sp";
export var imageContainer = "PricesGroup-module--imageContainer--YjMfx";
export var image = "PricesGroup-module--image--3kaDQ";
export var content = "PricesGroup-module--content--2OsLw";
export var list = "PricesGroup-module--list--3XMKA";
export var listElement = "PricesGroup-module--listElement--ZBPFJ";
export var title = "PricesGroup-module--title--2Jz5H";
export var price = "PricesGroup-module--price--2L405";